import "./UserPermissionsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import SwitchComponent from "../../../../shared/components/core/switch/switchComponent";
import CommonService from "../../../../shared/services/common.service";
import commonService from "../../../../shared/services/common.service";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../constants";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import {Grid} from "@material-ui/core";
import SelectDropdownComponent from "../../../../shared/components/core/select-dropdown/SelectDropdownComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";

interface UserPermissionsViewEditComponentProps {
    userID: any;
    roleID: any;
    canEdit: boolean;
    onModeChange: Function;
    isHybrid: boolean;
    isEditable?: boolean;
    initialUserRoleDetails: any;
    initialRoleDetails: any;
    onDetailsUpdate?: Function;
}


const UserPermissionsViewEditComponent = (props: UserPermissionsViewEditComponentProps) => {
    const {userID, roleID, isHybrid, isEditable, onDetailsUpdate, initialUserRoleDetails, initialRoleDetails} = props;

    const [isRoleHybrid, setIsRoleHybrid] = useState(isHybrid);
    const [roleId, setRoleId] = useState(roleID);
    const {roleList} = useSelector((state: IRootReducerState) => state.staticData);
    const [roleDetails, setRoleDetails] = useState<any>(initialRoleDetails);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [userRoleDetails, setUserRoleDetails] = useState<any>(initialUserRoleDetails);
    const [isUserRolesResetting, setIsUserRolesResetting] = useState(false);
    const [isRoleDetailsLoading, setIsRoleDetailsLoading] = useState(false);
    const [isRoleDetailsLoadingFailed, setIsRoleDetailsLoadingFailed] = useState(false);

    const getRoleDetails = useCallback((roleId: any) => {
        const payload = {};
        setIsRoleDetailsLoading(true);
        setIsRoleDetailsLoadingFailed(false);
        CommonService._accessLevel.getAccessLevelsOfRole(roleId, payload)
            .then((response: any) => {
                setIsRoleDetailsLoading(false);
                setIsRoleDetailsLoadingFailed(false);
                const data = response?.data?.map((item: any) => {
                    const features = item?.features?.map((featureItem: any) => {
                        return {...featureItem, isDefault: featureItem.isAccessible}
                    })
                    return {...item, features: features, isDefault: item.isAccessible}
                })
                setRoleDetails(data)
                setUserRoleDetails((oldState: any) => {
                        if (!oldState) {
                            return data;
                        } else {
                            return oldState;
                        }
                    }
                )
            })
            .catch((error: any) => {
                setIsRoleDetailsLoading(false);
                setIsRoleDetailsLoadingFailed(true);
                setUserRoleDetails(undefined)
                commonService._alert.showToast(error?.error, "warning");
            })
    }, []);

    const handleModuleAccessChange = useCallback((module: string, isAccessible: boolean) => {
        setUserRoleDetails((prevState: any) => {
            const updatedData = prevState.map((item: any) => {
                if (item.module === module) {
                    if (isAccessible) {
                        const featuseDeselected = item.features.map((featureItem: any) => {
                            return {...featureItem, isAccessible: false}
                        })
                        return {...item, features: featuseDeselected, isAccessible: !item.isAccessible}
                    }
                    return {...item, isAccessible: !item.isAccessible}
                }
                return item;
            })
            return updatedData;
        })
    }, [])

    const handleFeatureAccessChange = useCallback((accessLevelDetails: any, module: string, feature: string) => {
        const data = _.cloneDeep(accessLevelDetails);
        const updatedData = data.map((prevState: any) => {
            if (prevState.module === module) {
                const featureData = prevState.features.map((featureItem: any) => {
                    if (featureItem.feature === feature) {
                        return {...featureItem, isAccessible: !featureItem.isAccessible}
                    }
                    return featureItem;
                })
                return {...prevState, features: featureData}
            }
            return prevState;
        })

        setUserRoleDetails(updatedData);
    }, [])

    const addUserRole = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: "Please Confirm",
            confirmationSubTitle: "This will end the current user's session. They'll need to login again after the change. Proceed with the changes?",
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Update",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "secondary"
            },
        }).then(() => {
            setIsSubmitting(true);
            const payload = {
                'aclRules': userRoleDetails,
                'isHybrid': isRoleHybrid
            };
            CommonService._user.adduserRoles(userID, roleId, payload)
                .then((response: any) => {
                    if (isEditable) {
                        const userPayload = {
                            roleId: roleId,
                            roleObj: roleList.find((role: any) => role?.id === roleId),
                        }
                        CommonService._user.editUser(userID, userPayload)
                            .then((response: any) => {
                                onDetailsUpdate && onDetailsUpdate(response?.data)
                                commonService._alert.showToast(response?.message, "success");
                            })
                            .catch((error: any) => {

                            })
                    } else {
                        commonService._alert.showToast(response?.message, "success");
                    }
                    setIsSubmitting(false);
                })
                .catch((error: any) => {
                    setIsSubmitting(false);
                    commonService._alert.showToast(error?.error, "warning");
                })

        }).catch(() => {
            setIsSubmitting(false);
        })
    }, [roleId, onDetailsUpdate, userRoleDetails, userID, isRoleHybrid, isEditable, roleList]);

    useEffect(() => {
        let hybrid = isHybrid;
        userRoleDetails?.length > 0 && userRoleDetails?.forEach((item: any, index: number) => {
            if (item.isAccessible !== roleDetails[index]?.isAccessible) {
                hybrid = true;
            }
            item.features.forEach((feature: any, index: number) => {
                if (feature.isAccessible !== roleDetails[index]?.features[index]?.isAccessible) {
                    hybrid = true;
                }
            })
        })
        setIsRoleHybrid(hybrid);
    }, [userRoleDetails, roleDetails, isHybrid]);

    const resetUserRoleDetails = useCallback(() => {
        const payload = {
            'aclRules': roleDetails,
            'isHybrid': false
        };
        setIsUserRolesResetting(true);
        CommonService._user.adduserRoles(userID, roleId, payload)
            .then((response: any) => {
                setIsUserRolesResetting(false);
                setIsRoleHybrid(false);
                setUserRoleDetails(roleDetails);
                commonService._alert.showToast(response?.message, "success");
            })
            .catch((error: any) => {
                setIsUserRolesResetting(false);
                commonService._alert.showToast(error?.error, "warning");
            })
    }, [roleDetails, roleId, userID]);

    const onChangeOfRoleId = useCallback((roleId: any) => {
        setRoleId(roleId);
        setUserRoleDetails(undefined);
        setIsRoleHybrid(false);
        getRoleDetails(roleId)
    }, [getRoleDetails]);

    return (
        <div className={'user-permissions-view-edit-component'}>
            {
                isRoleDetailsLoading &&
                <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isRoleDetailsLoadingFailed &&
                <StatusCardComponent title={'Failed to load user role details'}/>
            }
            {
                !(isRoleDetailsLoading || isRoleDetailsLoadingFailed) &&

                <div className={'access-level-details-body-wrapper'}>
                    {
                        isEditable &&
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <SelectDropdownComponent
                                    label={"Select Role"}
                                    id={"role"}
                                    name={"role"}
                                    placeholder={"Search Role Name"}
                                    required={true}
                                    multiple={false}
                                    valueKey={"id"}
                                    onUpdate={(value: any) => {
                                        onChangeOfRoleId(value)
                                    }}
                                    value={roleId}
                                    options={roleList}
                                    getOptionLabel={(option: any) => option?.role}
                                />
                                <div className="add_role_wrapper">
                                    <div>Didn’t find the role?</div>
                                    <a className="create-role-link"
                                       href={CommonService._routeConfig.AccessRoleAddRoute()}
                                       target={'_blank'} rel="noreferrer">Add Role</a>
                                </div>
                            </Grid>

                        </Grid>
                    }
                    <div className={'access-level-details-body-title'}>
                        Module-wise Permissions
                        <div>
                            <ButtonComponent
                                color={"secondary"}
                                type={"button"}
                                disabled={!isRoleHybrid}
                                variant={"outlined"}
                                fullWidth={false}
                                isLoading={isUserRolesResetting}
                                handleClick={resetUserRoleDetails}
                                startIcon={<RestartAltIcon/>}
                            >
                                Reset to Defaults
                            </ButtonComponent>
                        </div>
                    </div>
                    <div className={'access-level-details-body-description'}>
                        Ensure that the essential module is activated for the designated user role in
                        order
                        to access
                        its associated features. Once a module is activated, the user can enable these
                        features
                        individually.
                    </div>
                    <div className={'horizontal-line'}></div>
                    {
                        userRoleDetails?.length > 0 && userRoleDetails?.map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    <div className={'access-level-details-body-module-and-feature-wrapper'}>
                                        <div className={'access-level-details-body-module-wrapper'}>
                                            <div
                                                className={'access-level-details-body-module-title-description-wrapper'}>
                                                <div className={'access-level-details-body-module-title'}>
                                                    {item.module}
                                                </div>
                                                <div
                                                    className={'access-level-details-body-module-description'}>
                                                    {`Access to edit the features of ${item.module}
                                                                module.`}
                                                </div>
                                            </div>
                                            <div
                                                className={'access-level-details-body-module-switch-wrapper'}>
                                                <SwitchComponent
                                                    size={"small"}
                                                    checked={item.isAccessible}
                                                    readOnly={item.isDefault}
                                                    disabled={item.isDefault}
                                                    onUpdate={() => handleModuleAccessChange(item.module, item?.isAccessible)}/>
                                            </div>
                                        </div>
                                        <div className={'access-level-details-body-feature-wrapper'}>
                                            {
                                                item.isAccessible && item.features.map((feature: any, index: number) => {
                                                    let isReadOnly = feature?.isPrimary || feature?.isDefault;
                                                    if (isReadOnly) {
                                                        feature.isAccessible = true;
                                                    }
                                                    return (
                                                        <div className={'access-level-details-feature-wrapper'}
                                                             key={`${feature.feature}-${index}`}>
                                                            <div
                                                                className={'access-level-details-body-feature-title-description-wrapper'}
                                                                key={index}>
                                                                <div
                                                                    className={'access-level-details-body-feature-title'}>
                                                                    {feature.feature}
                                                                </div>
                                                                <div
                                                                    className={'access-level-details-body-feature-description'}>
                                                                    {feature.description}
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={'access-level-details-body-feature-switch-wrapper'}>
                                                                <SwitchComponent
                                                                    size={"small"}
                                                                    readOnly={isReadOnly}
                                                                    disabled={isReadOnly}
                                                                    checked={feature.isAccessible}
                                                                    onUpdate={() => handleFeatureAccessChange(userRoleDetails, item.module, feature?.feature)}/>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className={'horizontal-line'}></div>
                                </div>
                            )
                        })
                    }
                    <div className={"form-action-section-edit"}>
                        <ButtonComponent
                            className={"width-25"}
                            color={"primary"}
                            type={"submit"}
                            variant={"contained"}
                            fullWidth={false}
                            handleClick={addUserRole}
                            isLoading={isSubmitting}
                        >
                            Save Changes
                        </ButtonComponent>
                    </div>
                </div>
            }
        </div>
    );

};

export default UserPermissionsViewEditComponent;
